import { Ray, Vector2, Vector4 } from 'three';
import { SettingState } from '../../../cross-team-shared/state/setting-state';
import { Point3D } from '../../../team-apis/otterdam/answers/shape-typings';
import { PointCloudContentState } from '../../state/point-cloud-content-state';
import {
  AbstractProjectionUtils,
  ProjectTo2DOptions,
} from './abstract-projection-utils';

export class PinholeProjectionUtils extends AbstractProjectionUtils {
  private readonly vec4Position = new Vector4();
  private readonly projectedInImage = new Vector2();

  projectTo2D(
    point: Point3D,
    settingState: SettingState,
    state: PointCloudContentState,
    options: ProjectTo2DOptions,
  ) {
    this.updateProjectionCamera(state, settingState, options.outputName);
    const imageSize = this.getImageSize(state, options.outputName);

    this.vec4Position.fromArray([...point, 1]);

    // To clip space
    // projectionMatrix * modelViewMatrix * vec4(h3Position, 1.0)
    const clipSpace = this.localToClipSpace(this.vec4Position, options);

    const clipSpaceW = clipSpace.w;
    const clipSpaceZ = clipSpace.z;

    // To NDC
    const ndc = clipSpace.divideScalar(clipSpace.w);

    // (ndc * imageSize + imageSize) / 2.0;
    this.projectedInImage
      .fromArray(ndc.toArray())
      .multiply(imageSize)
      .add(imageSize)
      .divideScalar(2);

    return {
      position: this.projectedInImage.toArray(),
      isInsideFrustum: this.isWithinFrustum(
        this.projectedInImage,
        imageSize,
        clipSpaceW,
        clipSpaceZ,
      ),
    };
  }

  projectTo3D(): Ray {
    throw new Error('3D projection not supported for pinhole camera');
  }
}
